var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumAiLogoFullMarkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4080.9 1440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1684.77,902v-184.64h-191.98v184.64h-50.26v-400.34h50.26v167.14h191.98v-167.14h50.25v400.34h-50.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2152.3,909.34c-89.78,0-146.24-54.21-146.24-154.15v-253.53h50.25v254.66c0,63.81,26.54,106.16,95.99,106.16s95.99-42.35,95.99-106.16v-254.66h50.25v253.53c0,99.94-56.47,154.15-146.25,154.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2905.55,902v-337.66l-124.22,332.02h-39.53l-124.22-334.84v340.49h-48v-400.34h72.28l120.84,325.81,120.27-325.81h70.58v400.34h-48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3197.32,902v-67.19h66.63v67.19h-66.63Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4029.52,902v-400.34h51.38v400.34h-51.38Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3768.39,902l-32.75-94.86h-173.91l-32.18,94.86h-50.82l141.16-400.34h58.72l141.73,400.34h-51.95ZM3648.12,551.91l-70.58,207.79h141.73l-71.15-207.79Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "576 288 576 576 288 576 288 288 576 288 576 0 288 0 288 288 0 288 0 1152 288 1152 288 1440 576 1440 576 1152 288 1152 288 864 576 864 576 1152 864 1152 864 288 576 288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumAiLogoFullMarkWhite);
export default __webpack_public_path__ + "static/media/HUM-AI-Logo-Full-Mark-White.1cc0bcd91a5fdf2bb09b73a24edf082e.svg";
export { ForwardRef as ReactComponent };